module.exports = __webpack_public_path__ + "static/installationspartner-env1-min-306efdb5416da8678a012a4d56c0e421.jpg";